import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';


export const useRowNavigation = ({routePrefix, idField}) => {
    const navigate = useNavigate();

    return useCallback((record) => {
        let clickTimer= null;

        const handleNavigation = () => {
            navigate(`${routePrefix}/${record[idField]}`);
        };

        return {
            onDoubleClick: () => {
                if (clickTimer) {
                    clearTimeout(clickTimer);
                }
                handleNavigation();
            },
            onClick: () => {
                if (clickTimer) {
                    clearTimeout(clickTimer);
                }
                clickTimer = setTimeout(() => {
                    // Single click action (if needed)
                }, 250);
            },
            onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    handleNavigation();
                }
            },
            role: 'button',
            tabIndex: 0,
        };
    }, [navigate, routePrefix, idField]);
};

export function isBoolean(n) {
    return !!n === n;
}

export const checkIsPhoneCorrect = (phone) => {
    if (phone === undefined || phone === null) {
        return ""
    }

    const normalizedPhone = String(phone);

    if (normalizedPhone.startsWith("+998")) {
        return normalizedPhone.substring(4);
    } else if (normalizedPhone.length > 11 && normalizedPhone.startsWith("998")) {
        return normalizedPhone.substring(3);
    } else if (normalizedPhone.startsWith("+")) {
        return normalizedPhone.substring(1);
    }
    return normalizedPhone;
};
